import { looseComponentSchema } from '@wix/cli-app-manifest';
import type {
  LooseAppManifest,
  LooseBaseComponent,
} from '@wix/cli-app-manifest';
import { ComponentType } from '@wix/ambassador-devcenter-apps-v1-app-old/types';

export function isTunnelRequired(appManifest: LooseAppManifest) {
  for (const extension of appManifest.components) {
    const knownAppManifest = parseKnownExtensionManifest(extension);

    if (
      knownAppManifest != null &&
      knownAppManifest.compType === ComponentType.WEBHOOK
    ) {
      // User can specify his own callback URL.
      // In such cases tunnel is not required even if webhook exists.
      // CLI always creates a relative URL which is not parsable.
      return !URL.canParse(knownAppManifest.compData.webhook.callbackUrl);
    }
  }

  return false;
}

function parseKnownExtensionManifest(extensionManifest: LooseBaseComponent) {
  const appManifestResult = looseComponentSchema.safeParse(extensionManifest);

  if (appManifestResult.error) {
    return null;
  }

  return appManifestResult.data;
}
